import styled from "styled-components";

export const PutAwayModalWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  p {
    margin: 0;
  }

  .title {
    margin-right: auto;
    font-size: 20px;
    font-weight: 600;
    color: var(--dark);
  }
  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .subtitle {
      font-size: 14px;
      color: var(--dark-light);
    }

    .batch span {
      color: var(--accent);
      font-weight: 600;
    }
  }
  .selectRack {
    display: flex;
    flex-direction: column;
    gap: 10px;
    .label {
      font-size: 18px;
    }
  }
  .suggested {
    display: flex;
    gap: 10px;
    .selectBinBtn {
      flex: 3;
      color: white;
      border: 2px solid var(--accent);
      color: var(--accent);
      background-color: #fff;
      border-radius: 5px;
      display: flex;
      align-items: center;
      justify-content: center;
      /* font-size: 16px; */
      /* padding: 5px 10px 10px; */
    }
    .ant-btn-loading-icon {
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .refreshBtn {
      background-color: white;
      border: none;
      display: flex;
      align-items: center;
      justify-content: center;
      border: 2px solid var(--accent);
      border-radius: 5px;
    }
  }
  .selectRackWrapper {
    display: flex;
    align-items: stretch;
    justify-content: space-between;
    gap: 10px;

    @media (max-width: 767px) {
      flex-flow: column;
      justify-content: flex-start;
      align-items: flex-start;
    }
    .scanBtn {
      border: none;
      background-color: var(--accent);
      color: #fff;
      border-radius: 5px;
      padding: 0 10px;
      width: 100%;
      min-height: 40px;
    }
    @media screen and (max-width: 425px) {
      flex-direction: column;
      align-items: stretch;
      .scanBtn {
        padding: 8px 0;
      }
    }
  }
  .selectedRack {
    display: flex;
    align-items: center;
    font-size: 16px;
    gap: 10px;
    font-weight: 500;
    .value {
      font-size: 1.4em;
      color: var(--accent);
      display: flex;
      align-items: center;
    }
  }
  .selectQtyLabel {
    font-size: 17px;
  }
  .isBinEmpty {
    display: flex;
    align-items: center;
    gap: 10px;
    .label {
      font-size: 17px;
    }
  }

  .subtmitBtnWrapper {
    display: flex;
    justify-content: center;
    .submit {
      font-size: 17px;
      background-color: ${({ submitDisabled }) =>
        submitDisabled ? "grey" : "var(--accent)"};
      color: #fff;
      border: none;
      padding: 8px 25px;
      border-radius: 5px;
    }
  }
`;
